import type { ImportPublishedRulebookResult } from "@next-platform/client-common-core";

import { ROUTES } from "@/constants/navigation";

export type RulebookCloneOutcome = { ok: true; path: string } | { ok: false; fallbackPath: string };

/** Outcome for a clone that reached the server but could not be opened locally. */
export const RULEBOOK_CLONE_NOT_OPENED_OUTCOME: RulebookCloneOutcome = {
  ok: false,
  fallbackPath: ROUTES.myCreationRulebook,
};

/** importPublishedRulebook resolves instead of throwing — only "imported" results navigate to the draft;
a failed import still left the clone on the server, so the fallback points at My Rulebooks. */
export default function resolveRulebookCloneOutcome(result: ImportPublishedRulebookResult): RulebookCloneOutcome {
  if (result.status !== "imported") {
    return RULEBOOK_CLONE_NOT_OPENED_OUTCOME;
  }
  return { ok: true, path: `${ROUTES.rulebookEditor}/${result.draftId}` };
}
